
import './ProfileEditSection.scss';
export default function ProfileEditSection(props: any) {
    return (
        <section data-testid="profiles-wrapper" width="100%" className="sc-drMfKT clmMEq ">
            <h2 className="text-color--primary padding--bottom-6">Edit Profiles</h2>
            <h4 className="text-color--secondary">Select a profile to edit</h4>
            {props.children}
        </section>
    );
}